import WebsiteBehaviors from "../website-behaviors/index.js";

class AUCTR extends WebsiteBehaviors {
	identifier() {
		return "AUCTR";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "radar.auctr.edu";
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default AUCTR;
